import { render } from "./LightboxProductBestSellerSkeleton.vue?vue&type=template&id=c19997c8&scoped=true"
import script from "./LightboxProductBestSellerSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxProductBestSellerSkeleton.vue?vue&type=script&lang=js"

import "./LightboxProductBestSellerSkeleton.vue?vue&type=style&index=0&id=c19997c8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c19997c8"]])

export default __exports__